import React from 'react';
import { i18n } from 'utils/i18n';
import { useSelector } from 'react-redux';
import { sanitize } from 'utils/validation';
import { analyticsInteraction } from 'utils/analytics';
import MODAL, { MODAL_THEMES, MODAL_BUTTON_TYPES } from 'constants/modals';
import ANALYTICS from 'constants/analytics';
import useSupportPhoneNumber from 'hooks/useSupportPhoneNumber';
import Modal from 'components/Modal';
import {
  getPickupLocationCountryCode,
  getReservationLimitedAdvanceNoticeIndicator,
} from 'selectors/reservationSelectors';
import { getAlamoDisabilitiesSupportPhoneNumber } from 'selectors/supportSelectors';
import { ModalFooter } from 'components/Modal/ModalFooter';

const { ACCEPT, DECLINE } = MODAL_BUTTON_TYPES;

const LimitedAdaptiveEquipment = () => {
  // Fetching the support Contact Details.
  useSupportPhoneNumber();
  const pickupLocationCountryCode = useSelector(getPickupLocationCountryCode);
  const reservationLimitedAdvanceNoticeIndicator = useSelector(getReservationLimitedAdvanceNoticeIndicator);
  const alamoDisabilitiesSupportPhoneNumber = useSelector((state) =>
    getAlamoDisabilitiesSupportPhoneNumber(state, pickupLocationCountryCode)
  );

  const modalHeader = i18n(
    reservationLimitedAdvanceNoticeIndicator
      ? 'adaptive_driving_device_call_to_confirm'
      : 'adaptive_equipment_modal_title'
  );
  const modalContent = reservationLimitedAdvanceNoticeIndicator
    ? i18n('adaptive_driving_devices_must_be_installed', [alamoDisabilitiesSupportPhoneNumber])
    : i18n('adaptive_equipment_modal_content');

  const modalAnalyticsKey = reservationLimitedAdvanceNoticeIndicator
    ? ANALYTICS.LIMITED_TIME_ADAPTIVE_DRIVING_DEVICE
    : ANALYTICS.ADAPTIVE_DRIVING_DEVICE;

  return (
    <Modal
      modalKey={MODAL.ADAPTIVE_DRIVING_DEVICE}
      header={modalHeader}
      theme={MODAL_THEMES.WHITE}
      customClass='limited_inventory__modal'
      customActionOnClose={() => analyticsInteraction(ANALYTICS.MODAL, modalAnalyticsKey, ANALYTICS.CLOSE)}
      // We need to pass skip analytics for the "clearModalQueue" action if we are pushing _analytics.interaction manually on open/close modal
      handleModalQueue={{ skipAnalytics: true }}
    >
      {({ handleAccept, handleClose, code }) => (
        <>
          <p id={`${MODAL.ADAPTIVE_DRIVING_DEVICE}_desc`} dangerouslySetInnerHTML={sanitize(modalContent)}></p>
          <ModalFooter
            buttons={[
              {
                type: DECLINE,
                label: i18n('limited_inventory_modal_decline_extra'),
                analyticsHandler: () => analyticsInteraction(ANALYTICS.MODAL, modalAnalyticsKey, ANALYTICS.DO_NOT_ADD),
              },
              {
                type: ACCEPT,
                label: i18n('limited_inventory_modal_accept_extra'),
                handler: () => {
                  handleAccept();
                  handleClose();
                },
                analyticsHandler: () =>
                  analyticsInteraction(ANALYTICS.MODAL, modalAnalyticsKey, `${ANALYTICS.CONTINUE_ADDING} ${code}`),
              },
            ]}
          />
        </>
      )}
    </Modal>
  );
};

export default LimitedAdaptiveEquipment;
